import { ReactNode, useEffect, useRef, useState } from 'react';
import './expandable.css';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import mySvg from '../../assets/chvron.svg';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import mySvgWhite from '../../assets/chevron-white.svg';

interface ExpandableComponentProps {
  title: string;
  top: ReactNode;
  bottom: ReactNode;
  displayChevron?: boolean;
  makeAbsolute?: boolean;
  bottomLeft?: number;
  onExpandOrCollapse?: (isExpand: boolean) => void;
}

const Expandable: React.FC<ExpandableComponentProps> = ({
  top,
  bottom,
  title,
  displayChevron,
  makeAbsolute = false,
  onExpandOrCollapse = null,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const rootElementRef = useRef<HTMLDivElement>(null);

  const expandOrCollapse = () => {
    if (onExpandOrCollapse) {
      onExpandOrCollapse(!isOpen);
    }
    setIsOpen(!isOpen);
  };

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const handleClickOutside = (event) => {
    if (
      rootElementRef.current &&
      !rootElementRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    // Add event listener to the document
    document.addEventListener('mousedown', handleClickOutside);

    // Remove event listener on cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={rootElementRef}>
      <div
        onClick={expandOrCollapse}
        className={'expandable-root-top'}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className={'expandable-content'}>{top}</div>

        {displayChevron && (
          <img
            className={'svg-overlay'}
            src={isHovered ? mySvgWhite : mySvg}
            alt="description"
            style={{ transform: `rotate(${isOpen ? -90 : 0}deg)` }}
          />
        )}
      </div>
      {isOpen && (
        <div className={makeAbsolute ? 'expandable-content-absolute' : ''}>
          {bottom}
        </div>
      )}
    </div>
  );
};

export default Expandable;
